import React, { useState, useEffect } from 'react'
import { ScopeComponent } from './CreateCustomRole';
import { getAllPermissions, getAllPermissionsByCompanyType, getARoleByID } from '../../../../api/requests';
import { useQuery } from '@tanstack/react-query';
import Loader from '../../../../components/Loader';
import { showToast } from '../../../../utils/miscFunctions';

export interface IPermission {
    category: string;
    description: string;
    key:string;
    title:string;
}
interface IRoleList {
   userCompanyType?: string;
    isByCompanyType: boolean;
    name?: string;
    staffPermissions?: IPermission[];
    setPermissionsList?: (selected: string[]) => void;
    setUnselectedPermissionsList?: (unselected: string[]) => void;
    setListOfUnselectedPermissions?: (selected: string[], unselected: string[]) => void;
}

const RoleList = ({userCompanyType, isByCompanyType, name, staffPermissions , setPermissionsList, setUnselectedPermissionsList}:IRoleList) => {
 
    const [selectedPermissions, setSelectedPermissions] = useState<string[]>([])
    const [unselectedPermissions, setUnselectedPermissions] = useState<string[]>([])
    const [staffUnselectedPermissions, setStaffUnselectedPermissions] = useState<IPermission[]>([]);
    const staffUnselectedPermissionsKeys = staffUnselectedPermissions.map((p:IPermission) => {return p.key})
    
    // Get existing staff permission keys
    const staffPermsKeys = staffPermissions?.map(perm => perm.key) || []

    const { data: permissionsData, isLoading: isLoadingPermissions } = useQuery({
    queryKey: ['fetchPermissions'],
    queryFn: () => fetchPermissions(),
    enabled: !(isByCompanyType)
  });

   const { data: permissionsDataByCompanyType} = useQuery({
    queryKey: ['fetchAllPermissionsByCompanyType'],
    queryFn: () => fetchAllPermissionsByCompanyType(),
    enabled: !!isByCompanyType
  });
    
          const fetchPermissions = async () => {
        try {
          const response: any = await getAllPermissions();
          if (response) {
            return response;
          }
        } catch (error: any) {
          showToast.error(error.description);
        }
      };

     const fetchAllPermissionsByCompanyType = async () => {
        try {
          const response: any = userCompanyType && await getAllPermissionsByCompanyType(userCompanyType);
          if (response) {
            return response.scopes;
          }
        } catch (error: any) {
          showToast.error(error.description);
        }
      };


   

   const list = (data:any) => {

    const elements: JSX.Element[] = [];
    const _permissions =  Object?.entries(data);
    
    const transformedArray = _permissions.map(([key, value]) => ({
      key: key,
      value: value
    }));
    const _transformedArray = transformedArray.sort((a, b) => a.key.localeCompare(b.key));

    
    _transformedArray.forEach((permission, index) => {
      elements.push(
        <div key={index}>
          <ScopeComponent
            label={permission.value as string}
            scope={permission.key}
            checked={false}
            onChange={handlePermissionChange}
            disabled
          />
        </div>
      );
    }); 
    return elements
}

  // Function to handle checkbox changes and collect selected permissions
  const handlePermissionChange = (data: { scope: string; checked: boolean; label: string }) => {
    setSelectedPermissions(prev => {
      if (data.checked) {
        // Add permission if checked and not already in array
        return prev.includes(data.scope) ? prev : [...prev, data.scope];
      } else {
        // Remove permission if unchecked
        return prev.filter(scope => scope !== data.scope);
      }
    });

    // Also track unselected permissions
    setUnselectedPermissions(prev => {
      if (data.checked) {
        // Remove from unselected if now checked
        return prev.filter(scope => scope !== data.scope);
      } else {
        // Add to unselected if now unchecked
        return prev.includes(data.scope) ? prev : [...prev, data.scope];
      }
    });
  };

const deselectedStaffPermissions = (permission: IPermission) => {
  setStaffUnselectedPermissions((staffPermissions) => {
    const exists = staffPermissions?.find((p) => p.key === permission.key);
    
    if (exists) {
      return staffPermissions.filter((p) => p.key !== permission.key); // remove
    } else {
      return [...staffPermissions, permission]; // add
    }
  });
};

  // Calculate final permissions to send
  const calculateFinalPermissions = () => {
    // Start with existing staff permissions
    const basePermissions = new Set(staffPermsKeys)
    
    // Add newly selected permissions
    selectedPermissions.forEach(perm => basePermissions.add(perm))
    
    // Remove deselected permissions
    unselectedPermissions.forEach(perm => basePermissions.delete(perm))
    
    return Array.from(basePermissions)
  }

  // Log selected permissions whenever they change
  useEffect(() => {
    const finalPermissions = calculateFinalPermissions()
    
    setPermissionsList?.(finalPermissions)
    setUnselectedPermissionsList?.(unselectedPermissions)
    
  }, [selectedPermissions]);

   const listByCompanyType = (data:any) => {

    const elements: JSX.Element[] = [];

    data.forEach((permission: any, index: number) => {
      elements.push(
        <div key={index}>
          <ScopeComponent
            label={permission.description as string}
            scope={permission.key}
            checked={false}
           onChange={(data) => {
            handlePermissionChange(data);
            deselectedStaffPermissions({ key: data.scope, description: data.label, title: '', category: '' });
            }}
            staffPerms={staffPermissions}
            disabled={false}
          />
        </div>
      );
    }); 
    return elements
}

if(!permissionsData && !permissionsDataByCompanyType){
    return <Loader message='Fetching list of permissions...' brollyLoaderFixed/>
}
    return ((permissionsData ||  permissionsDataByCompanyType) && 
      <div className={`grid grid-cols-1 ${isByCompanyType ? 'md:grid-cols-1' : 'md:grid-cols-2'}`}>
        {!isByCompanyType ? list(permissionsData) : listByCompanyType(permissionsDataByCompanyType)}
      </div>);
  };


export default RoleList